
const __default__ = {
  props: {
    color: {type: String, default: ''},
    icon: {type: String, default: ''},
    border: {type: Boolean, default: true},
    iconColor: {type: String, default: 'var(--primary-700)'},
    rounded: {type: Boolean, default: true},
    uppercase: {type: Boolean, default: false},

    brand: {type: Boolean, default: false},
    gray: {type: Boolean, default: false},
    indigo: {type: Boolean, default: false},
    error: {type: Boolean, default: false},
    success: {type: Boolean, default: false},
    blue: {type: Boolean, default: false},
    small: {type: Boolean, default: false},

    open: {type: Boolean, default: true},
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "e04e13ba-color": (_ctx.color),
  "e04e13ba-iconColor": (_ctx.iconColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__